// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"80298eca","239":"9a158fa3","283":"b149dd0b","407":"ea3863ac","436":"8d246c85","483":"a9831c84","489":"da221363","511":"ca1430f3","590":"18713778","618":"24597152","756":"89fa50c2","759":"ea502626","972":"1126ee2b"}[chunkId] + ".chunk.js";
};